import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORM_SUBMISSIONS } from "../domain";

import { submissionsApi } from "@api/services";
import { DOMAIN_FORMS, ACTION_GET_AVAILIBLE_FORMS, roleGuard, DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO } from "@api";

export const ACTION_CREATE_SUBMISSION = "CREATE_SUBMISSION";

const allowedRoles = [UserRole.Owner];

type CreateSubmissionRequest = {
  formId: string;
  isCalculateOnly?: boolean;
};

const createSubmission = async (req: CreateSubmissionRequest): Promise<void> => {
  const { formId, isCalculateOnly = false } = req;
  const response = await submissionsApi.submissionsControllerCreateSubmission(
    formId,
    { isCalculateOnly },
  );

  return response.data;
};

export const useCreateSubmission = (
  user: UserProfileDto | null,
): {
  createSubmission: (req: CreateSubmissionRequest) => void;
  createSubmissionAsync: (req: CreateSubmissionRequest) => Promise<void>;
  createSubmissionEnabled: boolean;
  createSubmissionError: Error | null;
  isSuccessCreateSubmission: boolean;
  isPendingCreateSubmission: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_FORM_SUBMISSIONS, ACTION_CREATE_SUBMISSION],
    mutationFn: enabled ? createSubmission : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORM_SUBMISSIONS] });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FORMS, ACTION_GET_AVAILIBLE_FORMS],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
      });
    },
  });

  return {
    createSubmission: mutate,
    createSubmissionAsync: mutateAsync,
    createSubmissionEnabled: enabled,
    createSubmissionError: error,
    isSuccessCreateSubmission: isSuccess,
    isPendingCreateSubmission: isPending,
  };
};
